var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config)?_c(_vm.config.icon,{tag:"component",class:_vm.config.class,attrs:{"size":_vm.size}}):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }